

































































import { Component, Vue } from "vue-property-decorator";
import { Icon, Popup, Dialog, Empty } from "vant";
import i18n from "@/locales";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";

@Component({
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Empty.name]: Empty
  },
  filters: {
    filterCurrency(val) {
      const CURRENCY_MAP = {
        HKD: i18n.t("common.hkd"),
        USD: i18n.t("common.usd"),
        CNH: i18n.t("common.rmb")
      };
      let currencyList = val.split(",");
      currencyList = currencyList.map(item => {
        return CURRENCY_MAP[item];
      });
      return currencyList?.join(" ");
    }
  },
  computed: {
    cardNumber(){
      return (str) => {
        const noSpaces = str.replace(/\s/g, '');
        return noSpaces.match(/.{1,4}/g)?.join(' ');
      };
    }
  }
})
export default class BankcardList extends Vue {
  bankList: any = [];
  popUpVisible = false;
  isLoading = true;
  currData: any;
  netError = false;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;
  showType:any = 1; // 1 我的银行卡 2 资金转出  3激活
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.getList();
    this.showType = this.$route.query.showType || 1;
    // 根据 showType 设置标题  默認：我的銀行卡
    if(this.showType != 1){
      if(getBrowser().isApp){
        setStatementDetailInfo({
          headerTitle: this.$t('funds.pageTitle[2]')
        });
      }else{
        (document as any).title = this.$t('funds.pageTitle[2]')
      }
    }
  }

  handleAddCard() {
    this.$router.push({ name: "bank-card-add", query: {
      ...this.$route.query,
      } });
  }
  toPage(e){
    const { showType } = this;
    if(showType != 1){
      const { account_no, account_type } = this.$route.query;
      this.$router.push({
        path: '/app-pages/into-bank-card-list',
        query: {
          account_no,
          account_type,
          showType,
          card_id: e.id
        }
      })
    }

  }

  handlePopUpShow(item) {
    this.popUpVisible = true;
    this.currData = item;
  }

  handlePopUpHidden() {
    this.popUpVisible = false;
    this.currData = {};
  }

  handleCancelBind() {
    Dialog.confirm({
      title: `${this.$t("bankCard.domText[4]")}`,
      message: `${this.$t("bankCard.domText[5]")}`,
      className: this.bgColor == 'black-theme' ? 'black-theme-dialog' : ''
    })
      .then(() => {
        (this as any).$apis
          .delBankCard({ del_id: this.currData && this.currData.id })
          .then(res => {
            if(res.code != 0 && res.msg){
              
              this.$toast(res.msg);
            }else{
              this.popUpVisible = false;
              this.getList();
            }
          })
          .catch(err => {
            
          })
          .finally(() => {
            this.isLoading = false;
            this.popUpVisible = false;
          });
      })
      .catch(() => {
        // on cancel
      });
  }

  handleUpdateCard() {
    this.$router.push({
      name: "bank-card-add",
      query: { id: this.currData.id, ...this.$route.query }
    });
  }

  getList() {
    (this as any).$apis
      .getBankList()
      .then(res => {
        Array.isArray(res) && (this.bankList = res);
        
        this.isLoading = false;
        this.netError = false;
      })
      .catch(error => {
        
        this.netError = true;
        this.isLoading = false;
      });
  }
}
